"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RELEVANCE_EXPERIENCE_DETAILS = exports.RELEVANCE_CRITERIA = void 0;
const lib_custom_types_1 = require("@backend/lib-custom-types");
exports.RELEVANCE_CRITERIA = (0, lib_custom_types_1.strictUnionArray)()([
    'DISTANCE',
    'EXPERIENCE',
    'CERTIFICATES',
    'CV_SEARCH',
]);
exports.RELEVANCE_EXPERIENCE_DETAILS = (0, lib_custom_types_1.strictUnionArray)()([
    'EXPERIENCE_JOB',
    'EXPERIENCE_MIN_DURATION',
    'EXPERIENCE_MAX_DURATION',
    'EXPERIENCE_RECENCY',
]);
